// @flow

import Resource from 'speed-js-core/src/api/Resource';
import PhoneContactDetailResource from 'esm-web-pro/api/resources/PhoneContactDetailResource';
import FaxContactDetailResource from 'esm-web-pro/api/resources/FaxContactDetailResource';
import EmailContactDetailResource from 'esm-web-pro/api/resources/EmailContactDetailResource';
import AddressContactDetailResource from 'esm-web-pro/api/resources/AddressContactDetailResource';
import EntityPaymentMethodsResource from 'esm-web-pro/api/resources/EntityPaymentMethodsResource';
import ContactDetailResource from './ContactDetailResource';

export default class EntityResource extends Resource {
    basePath: string = 'entities/entities/';

    objectPath: string = 'entities/entities/{ident}/';

    searchPath: string = 'entities/search-entities/';

    _getSearchPath = () => this.searchPath;

    nestedResources = {
        details: ContactDetailResource,
        phoneDetails: PhoneContactDetailResource,
        faxDetails: FaxContactDetailResource,
        emailDetails: EmailContactDetailResource,
        addressDetails: AddressContactDetailResource,
        paymentMethods: EntityPaymentMethodsResource,
    };

    details: ContactDetailResource;

    phoneDetails: PhoneContactDetailResource;

    faxDetails: FaxContactDetailResource;

    emailDetails: EmailContactDetailResource;

    addressDetails: AddressContactDetailResource;

    paymentMethods: EntityPaymentMethodsResource;

    list(query: Object): Promise<Object> {
        return this.client._request(this._getSearchPath(), 'GET', query).then((response) => response.data);
    }
}
